import {AbstractControl, UntypedFormControl, ValidatorFn} from '@angular/forms';
import {ParametrosConst} from './parametrosConst';

export class ValidatorFunction {
  public static repetirPassValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const repetirPass = control.get('repetirContrasenia').value;
    if (repetirPass !== control.get('nuevaContrasenia').value) {
      return {
        equalsPassword: true
      };
    }
    return null;
  }

  public static requiredNumero(control: UntypedFormControl): { [key: string]: boolean } | null {
    if (ParametrosConst.PASS_REQUIRED_NUMERO) {
      if (!ValidatorFunction.containsLetra(control.value, ParametrosConst.PASS_NUMEROS)) {
        return {
          requiredNumero: true
        };
      }
    }
    return null;
  }

  public static requiredMinuscula(control: UntypedFormControl): { [key: string]: boolean } | null {
    if (ParametrosConst.PASS_REQUIRED_MINUSCULA) {
      if (!ValidatorFunction.containsLetra(control.value, ParametrosConst.PASS_MINUSCULAS)) {
        return {
          requiredMinuscula: true
        };
      }
    }
    return null;
  }

  public static requiredMayuscula(control: UntypedFormControl): { [key: string]: boolean } | null {
    if (ParametrosConst.PASS_REQUIRED_MAYUSCULA) {
      if (!ValidatorFunction.containsLetra(control.value, ParametrosConst.PASS_MAYUSCULAS)) {
        return {
          requiredMayuscula: true
        };
      }
    }
    return null;
  }

  public static requiredCaracterEspecial(control: UntypedFormControl): { [key: string]: boolean } | null {
    if (ParametrosConst.PASS_REQUIRED_CARACTER_ESPECIAL) {
      if (!ValidatorFunction.containsLetra(control.value, ParametrosConst.PASS_CARACTER_ESPECIAL)) {
        return {
          requiredCaracterEspecial: true
        };
      }
    }
    return null;
  }

  public static containsLetra(cadena: string, cadenaBusqueda: string) {
    const arrayLetra = cadenaBusqueda.split('');
    let valido = false;
    for (let index = 0; index < arrayLetra.length; index++) {
      if (cadena.includes(arrayLetra[index])) {
        valido = true;
        break;
      }
    }
    return valido;
  }

  public static different(cadena: string): ValidatorFn {
    return function(control) {
      const length = control.value ? control.value : '';
      return length === cadena ?
        {different: true, cadenaDiff: cadena} :
        null;
    };
  }
}
